<template>
  <div class="fe-text-heading-xxs lg:fe-text-heading-xs">
    Questions & Answers
  </div>
</template>

<script>
  export default {
    name: "QnATitle",
  }
</script>
